module.exports = __webpack_public_path__ + "img/rock-huge-14.2adecfcc.png";